<template>
  <el-table-column
    v-bind="column"
    :resizable="false"
    v-if="checkShow(column)"
    :align="column.align || 'center'"
  >
    <template slot="header">
      <slot name="header">
        <span v-if="column.required" class="dangerColor">*</span>
        <span :class="column.headerClass || ''">{{ column.label }}</span>
      </slot>
    </template>
    <!-- 递归渲染子列 -->
    <template v-if="column.group && column.group.length">
      <table-column
        v-for="child in column.group"
        :key="child.prop"
        :column="child"
      >
        <!-- 将父组件的同名 slot 传递给 TableColumn -->
          <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope" />
          </template>
      </table-column>
    </template>
    <template v-if="!column.group" #default="scope">
      <slot :name="column.prop" v-bind="scope">
        <span :class="[handleClass(scope, column)]">
          {{ handleRender(scope, column) | formatValue }}
        </span>
      </slot>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: "TableColumn",
  props: {
    column: {
      type: Object,
      required: true
    }
  },
  methods: {
    checkShow(opt) {
      return opt.show ? opt.show() : true;
    },
    handleClass({ row, $index }, { rowClass }) {
      if (rowClass) {
        return rowClass(row, $index);
      }
      return "";
    },
    handleRender({ row, $index }, { prop, formatData, formatter }) {
      if (formatData) {
        return formatData(row, $index);
      }
      // 关键步骤：兼容 Element 列配置里的 formatter，避免页面传了 formatter 却仍然回退成原始值。
      if (formatter) {
        return formatter(row, { property: prop }, row[prop], $index);
      }
      return row[prop];
    }
  },
  filters: {
    formatValue(value) {
      if (value || value === 0) {
        if (typeof value === "object") {
          let res = [];
          if (Array.isArray(value)) {
            res = value;
          } else {
            res = Object.values(value);
          }
          return res.length === 0 ? "--" : value;
        } else {
          if (value === "null" || value === "undefined" || value === "NaN") {
            return "--";
          }
          return value;
        }
      }
      return "--";
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-cell {
    background-color: #FFF;
}
</style>
